export default function FAQ() {
  const faqs = [
    {
      question: "How do I join the COMHAB/RESPITE list?",
      answer:
        "Go to the Join DSP page and complete the form. Once submitted, your profile will be reviewed before appearing publicly.",
    },
    {
      question: "Why is my profile not showing on the website?",
      answer:
        "Profiles only appear after they have been approved. If you recently updated your information, your profile may be pending review again.",
    },
    {
      question: "Can I update my profile later?",
      answer:
        "Yes. You can submit updated information at any time. If your profile was already approved, updating it may place it back under review.",
    },
    {
      question: "Can I sign up for both COMHAB and RESPITE?",
      answer:
        "Yes. You may choose one or both services when completing the DSP network form.",
    },
    {
  question: "What information is shown publicly?",
  answer:
    "Public listings will include your name, counties served, experience, certifications, specializations, schedule preferences, transportation availability, age groups served, languages spoken, and contact information such as phone number and email that you provide."
},
  ];

  return (
    <section className="container">
      <div className="card">

        <h1>Help</h1>


        {/* CONTACT SUPPORT FIRST */}
        <div className="contact-support">

          <h2>Contact Support</h2>

          <p>
            If you need assistance with profile updates, approval questions,
            technical issues, or general support, please contact us:
          </p>

          <p>
            <strong>Email:</strong> support@hopefulhorizonsny.com
          </p>

          {/*
          Phone support can be added later:

          <p>
            <strong>Phone:</strong> (555) 123-4567
          </p>
          */}

        </div>



        {/* FAQ SECTION */}
        <div className="faq-section">

          <h2>FAQ</h2>

          <div className="faq-list">
            {faqs.map((faq, index) => (
              <details key={index} className="faq-item">
                <summary>{faq.question}</summary>
                <p>{faq.answer}</p>
              </details>
            ))}
          </div>

        </div>


      </div>



      <style>{`

        .contact-support {
          margin-top: 10px;
          margin-bottom: 30px;
          padding: 22px;
          border-radius: 16px;
          background: #eef5fb;
          border: 1px solid #d7e3f3;
          text-align: left;
        }


        .faq-section h2 {
          margin-bottom: 15px;
        }


        .faq-list {
          text-align: left;
        }


        .faq-item {
          border: 1px solid #dbe1ea;
          border-radius: 14px;
          padding: 16px 18px;
          margin-bottom: 16px;
          background: #f9fbfd;
        }


        .faq-item summary {
          cursor: pointer;
          font-weight: 700;
          font-size: 1.05rem;
          color: #1f2937;
          list-style: none;
        }


        .faq-item summary::-webkit-details-marker {
          display: none;
        }


        .faq-item p {
          margin-top: 12px;
          color: #4b5563;
          line-height: 1.7;
          font-size: 1rem;
        }


      `}</style>

    </section>
  );
}